__webpack_require__.p = "/static/django/dist/";